module.exports = __webpack_public_path__ + "img/img1.6e726a6c.jpg";